import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "contexts/authContext";

import * as S from "./styles";

import { ReactComponent as Me } from "assets/Header/me-small.svg";

import { IUser } from "interfaces/User";

import NotificationModal from "../Modals/Notification";

interface HeaderProps {
  title?: string;
}

export function Header({ title }: HeaderProps) {
  const location = useHistory();

  const [user, setUser] = useState<IUser>();

  const { setIsAuthenticated } = useAuth();

  useEffect(() => {
    const stringUser = localStorage.getItem("user");
    if (stringUser) {
      const storageUser = JSON.parse(stringUser);
      setUser(storageUser);
    } else {
      setIsAuthenticated(false);
      location.push("/");
    }
  }, []);

  return (
    <S.HeaderContainer>
      <h2>
        {title}
        {user?.role.name === "Master" ? (
          <S.AdminFlag>Administrador</S.AdminFlag>
        ) : user?.role.name === "financial" ? (
          <S.AdminFlag>Financeiro</S.AdminFlag>
        ) : (
          ""
        )}
      </h2>
      <span>
        <NotificationModal />
        <h4>{user?.name}</h4>
        <S.ProfileLink to="/profile">
          <Me />
        </S.ProfileLink>
      </span>
    </S.HeaderContainer>
  );
}
